import { create } from "zustand";

export const useStoreTheme = create((set, get) => ({
    notificationSidebar: false,
    previewSidebar: false,
    sidebarCollapsed: false,

    setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
    toggleSidebar: () => set({ sidebarCollapsed: !get().sidebarCollapsed }),

    handleNotificationSidebar: () => {
        const { notificationSidebar, previewSidebar } = get();
        set({
            notificationSidebar: !notificationSidebar,
            previewSidebar: notificationSidebar ? previewSidebar : false,
        });
    },

    handlePreviewSidebar: () => {
        const { previewSidebar } = get();
        set({
            previewSidebar: !previewSidebar,
        });
    },
}));
